import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingCTA from '../../components/feature/FloatingCTA';
import ProductsHero from './components/ProductsHero';
import ProductDetails from './components/ProductDetails';
import { useSEO, generateOrganizationSchema, generateWebPageSchema, generateItemListSchema } from '../../utils/seo';

export default function ProductsPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || '';
  
  const productItems = [
    {
      name: 'Dalle LED 60x60 cm',
      description: 'Dalle LED haute performance 185 lm/W pour plafonds tertiaires',
      url: `${siteUrl}/nos-produits`
    },
    {
      name: 'Tube LED T8',
      description: 'Tube LED de remplacement haute efficacité énergétique',
      url: `${siteUrl}/nos-produits`
    },
    {
      name: 'Réglette LED',
      description: 'Réglette LED étanche pour environnements industriels',
      url: `${siteUrl}/nos-produits`
    },
    {
      name: 'Panneau LED',
      description: 'Panneau LED ultra-plat pour éclairage moderne',
      url: `${siteUrl}/nos-produits`
    },
    {
      name: 'Downlight LED',
      description: 'Spot encastrable LED pour éclairage directionnel',
      url: `${siteUrl}/nos-produits`
    },
    {
      name: 'Projecteur LED',
      description: 'Projecteur LED haute puissance pour espaces extérieurs',
      url: `${siteUrl}/nos-produits`
    }
  ];

  const schemas = [
    generateOrganizationSchema(),
    generateWebPageSchema(
      'Produits LED Professionnels 1€ - Dalles, Tubes, Réglettes | POWERENO',
      'Découvrez notre gamme complète de luminaires LED haute performance pour bâtiments tertiaires à Paris : dalles LED 185 lm/W, tubes LED, réglettes LED. Garantie 5 ans, financement CEE disponible.',
      `${siteUrl}/nos-produits`
    ),
    generateItemListSchema(productItems)
  ];

  useSEO({
    title: 'Produits LED Professionnels 1€ - Dalles, Tubes, Réglettes | POWERENO',
    description: 'Découvrez notre gamme complète de luminaires LED haute performance pour bâtiments tertiaires à Paris : dalles LED 185 lm/W, tubes LED, réglettes LED. Garantie 5 ans, financement CEE disponible.',
    keywords: 'dalle LED Paris, tube LED professionnel, réglette LED, luminaires tertiaires, éclairage LED industriel',
    canonical: `${siteUrl}/nos-produits`,
    schema: schemas
  });

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <ProductsHero />
        <ProductDetails />
        <Footer />
        <FloatingCTA />
      </div>
    </Suspense>
  );
}
